import { Result, Button, Flex, Image, Typography, Divider } from "antd";
import { Link } from "react-router-dom";
import BannerStore from "@/assets/img/store-banner.png";
import xconsLogo from "@/assets/img/logo-xcons.webp";

const { Text, Title } = Typography;

export const StoresPage = () => {
  return (
    <Flex justify="center" align="center" vertical gap={80}>
      <Flex vertical>
        <Flex
          align="center"
          vertical
          style={{
            backgroundImage: `url(${BannerStore})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            width: 965,
            height: 304,
          }}
        >
          <Flex
            justify="center"
            vertical
            style={{
              padding: 16,
              borderRadius: 20,
              width: 700,
              marginTop: 10,
            }}
          >
            <Title level={1} style={{ color: "#15744B", margin: 0 }}>
              Stores
            </Title>
            <Divider
              style={{
                height: 5,
                backgroundColor: "#85D025",
                width: 279,
                minWidth: "auto",
                margin: "8px 0",
                borderRadius: 100,
                border: "none",
              }}
            />

            <Title
              level={3}
              style={{
                margin: "24px 0 0 0",
                border: "1px solid #AEAEAE",
                borderRadius: 90,
                padding: "8px 24px",
                width: "fit-content",
              }}
            >
              Tu negocio, tu estrategia, tu control
            </Title>
            <Title level={5}>
              El showroom digital, diseñado para reflejar tu identidad, exhibir{" "}
              <br />
              tu catálogo y convertir cada visita en una oportunidad de venta.
            </Title>
          </Flex>
        </Flex>
        <Flex
          vertical
          style={{
            border: "1px solid #AEAEAE",
            borderTop: "none",
            borderRadius: "0 0 20px 20px",
            width: 965,
            marginTop: "-10px",
            padding: "24px 16px",
          }}
        >
          <Text strong>En XCONS desde tu Store podrás gestionar:</Text>

          <Text style={{ marginTop: 16 }}>
            Catálogos dinámicos y personalizados.
          </Text>
          <Divider
            style={{
              height: 5,
              backgroundColor: "#85D025",
              width: 40,
              minWidth: "auto",
              margin: 0,
              borderRadius: 100,
              border: "none",
            }}
          />

          <Text style={{ marginTop: 16 }}>
            Configuración de reglas para la derivación de ventas por ubicación,
            zonas o productos.
          </Text>
          <Divider
            style={{
              height: 5,
              backgroundColor: "#85D025",
              width: 40,
              minWidth: "auto",
              margin: 0,
              borderRadius: 100,
              border: "none",
            }}
          />

          <Text style={{ marginTop: 16 }}>
            Presupuestos y pedidos centralizados.
          </Text>
          <Divider
            style={{
              height: 5,
              backgroundColor: "#85D025",
              width: 40,
              minWidth: "auto",
              margin: 0,
              borderRadius: 100,
              border: "none",
            }}
          />

          <Text style={{ marginTop: 16 }}>
            Relaciones con clientes y Sellers conectados.
          </Text>
          <Divider
            style={{
              height: 5,
              backgroundColor: "#85D025",
              width: 40,
              minWidth: "auto",
              margin: 0,
              borderRadius: 100,
              border: "none",
            }}
          />
          <Text style={{ marginTop: 63 }}>
            ¿Querés saber cómo va a funcionar? Leelo aquí:{" "}
            <Link
              to="https://service.xcons.com/odoo/knowledge/209"
              target="_blank"
            >
              Documentación
            </Link>
          </Text>
        </Flex>
      </Flex>

      <img src={xconsLogo} alt="XCONS logo" style={{ width: 200 }} />
    </Flex>
  );
};
